<template>

  <div class="return-authorisation-express-form pad">
    <h1 class="title is-4">New Return Authorisation</h1>
    <div class="pad">
      <return-authorisation-form :express="true" @submitted="submitted" />
    </div>
  </div>

</template>

<script>
import ReturnAuthorisationForm from '@/components/ReturnAuthorisationForm'
export default {
  name: 'ReturnAuthorisationExpressForm',
  components: {
    ReturnAuthorisationForm
  },
  methods: {
    submitted () {
      this.$snackbar.open({
        message: 'Return authorisation successfully added!',
        type: 'is-success',
        position: 'is-bottom',
        indefinite: false
      })
      setTimeout(() => this.$router.push('return-authorisation'), 500)
    }
  }
}
</script>

<style>

</style>
